import type {RequestFilter} from './types';
import {authStore} from '../authentication/AuthenticationStore';

/**
 * Request filter for V2 payout method operations.
 *
 * This overrides the Authorization header to use the external account ephemeral key
 * (used by the external account form).
 *
 * The external account ephemeral key is required for these operations instead of the
 * standard account session key. This pattern is inspired by how we override the auth
 * header for V1 external account requests in `addExternalAccountFilter.ts`.
 */
export const addPayoutMethodFilter: RequestFilter = {
  matchers: [
    // Create a v2 payout method
    {
      urlPath: /\/graphql\/multiregion/,
      method: 'POST',
      body: /CreateV2OutboundSetupIntentMutation/,
    },
    // Archive a v2 payout method
    {
      urlPath: /\/graphql\/multiregion/,
      method: 'POST',
      body: /ArchiveV2PayoutMethodMutation/,
    },
  ],

  filterRequest: (requestData) => {
    const selectedApiKeyAndType = authStore.getApiKey('external_account');

    if (!selectedApiKeyAndType) {
      throw new Error('User has not stored external_account key');
    }

    const updatedRequest = {
      ...requestData.request,
      headers: {
        ...requestData.request.headers,
        Authorization: `Bearer ${selectedApiKeyAndType.key}`,
      },
    };

    return {
      ...requestData,
      request: updatedRequest,
    };
  },
};
